export const USERNAME_FIELD = 'username'
export const PASSWORD_FIELD = 'password'

export const SALUTATION_FIELD = 'salutation'
export const FIRSTNAME_FIELD = 'firstName'
export const LASTNAME_FIELD = 'lastName'
export const EMAIL_FIELD = 'email'
export const BIRTHDAY_DAY_FIELD = 'birthdayDay'
export const BIRTHDAY_MONTH_FIELD = 'birthdayMonth'
export const BIRTHDAY_YEAR_FIELD = 'birthdayYear'
export const NEWSLETTER_ACCEPTED_FIELD = 'newsletterAccepted'
export const TOS_ACCEPTED_FIELD = 'tosAccepted'

export const TARGET_PRODUCT_CODE_FIELD = 'targetProductCode'
export const TARGET_ANCHOR_FIELD = 'targetAnchor'
export const TARGET_PAGE_CODE_FIELD = 'targetPageCode'

export const LOGIN_REGISTER_ACTION_FIELD = 'action'
export const LOGIN_FORM_ACTION_FIELD_VALUE = 'loginForm'
export const REGISTER_FORM_ACTION_FIELD_VALUE = 'registerForm'
